import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

type Props = {
  open: boolean;
  onClose: (confirmed: boolean) => void;
};

export default function Disable2FADialog({ open, onClose }: Props) {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={() => onClose(false)}>
      <DialogTitle>Disable two-factor authentication (2FA)</DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle1" sx={styles.title}>
          This action only disables 2FA.
        </Typography>
        <Typography variant="body2">
          Disabling 2FA does not change the keys used in authenticator apps. If you wish to change
          the key used in an authenticator app you should reset your authenticator key.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(true)} color="error" variant="contained">
          Disable 2FA
        </Button>
        <Button onClick={() => onClose(false)} color="inherit" variant="text">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const styles = {
  title: {
    fontWeight: 600,
    mb: 1
  }
};
